import { useGetFriendlyUrl } from "utils/hooks/useGetFriendlyUrl";
import { httpService } from "utils";
import { DateObject } from "utils/DateObject";

import { useReactQuery } from "components/RemoteData";

import { IAppointment } from "../types/IAppointment";
import { IAppointmentDto } from "../Dtos/IAppointmentDto";

export const useGetAppointment = (appointmentId: string | number) => {
  const { friendlyUrl } = useGetFriendlyUrl();

  return useReactQuery(getAppointmentKey(appointmentId), () =>
    getAppointment(appointmentId, friendlyUrl)
  );
};

const getAppointment = (
  appointmentId: string | number,
  friendlyUrl: string
): Promise<IAppointment> => {
  return httpService()
    .get<IAppointmentDto>(
      `/e-reservation/${friendlyUrl}/appointment/${appointmentId}`
    )
    .then((appointment) => {
      return {
        ...appointment,
        createDate: appointment.createDate
          ? DateObject(appointment.createDate)
          : undefined,
        startDate: DateObject(appointment.startDate),
        endDate: DateObject(appointment.endDate),
      };
    });
};

export const getAppointmentKey = (appointmentId: string | number) => [
  "appointment",
  appointmentId,
];
